import React from 'react';
import {
  FaMapMarkerAlt,
  FaRoute,
  FaTruck,
  FaHistory,
  FaCar,
  FaMapMarkedAlt,
  FaArrowRight,
  FaCheckCircle,
  FaLocationArrow,
  FaClock,
  FaTachometerAlt,
} from 'react-icons/fa';

const Tracking = () => {
  const features = [
    { icon: <FaMapMarkerAlt />, text: 'Localisation des véhicules' },
    { icon: <FaLocationArrow />, text: 'Suivi en temps réel' },
    { icon: <FaHistory />, text: 'Historique des déplacements' },
    { icon: <FaTruck />, text: 'Gestion de flotte' },
    { icon: <FaRoute />, text: 'Suivi des trajets' },
    { icon: <FaMapMarkedAlt />, text: 'Visualisation cartographique' },
    { icon: <FaTachometerAlt />, text: 'Contrôle et optimisation' },
    { icon: <FaClock />, text: 'Données en temps réel' },
  ];

  return (
    <section id="tracking" className="tracking section section-alt">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Géolocalisation</span>
          <h2 className="section-title">Tracking & suivi de véhicules en temps réel</h2>
          <p className="section-subtitle">
            Nos solutions de géolocalisation vous permettent de suivre vos véhicules,
            d'optimiser vos déplacements et de contrôler votre flotte en toute simplicité.
          </p>
        </div>

        <div className="tracking-content">
          <div className="tracking-visual">
            <div className="tracking-map">
              <img
                src="/images/african-road.jpg"
                alt="Suivi de véhicule sur route en Afrique - Tracking"
                className="tracking-map-image"
                loading="lazy"
              />
              <div className="tracking-map-grid"></div>
              <div className="tracking-map-route">
                <div className="tracking-map-route-line"></div>
                <div className="tracking-map-route-point tracking-map-route-start"></div>
                <div className="tracking-map-route-point tracking-map-route-end"></div>
              </div>
              <div className="tracking-vehicle">
                <div className="tracking-vehicle-icon"><FaCar /></div>
                <div className="tracking-vehicle-pulse"></div>
              </div>
              <div className="tracking-map-marker tracking-map-marker-1">
                <FaMapMarkerAlt />
              </div>
              <div className="tracking-map-marker tracking-map-marker-2">
                <FaMapMarkerAlt />
              </div>
              <div className="tracking-map-marker tracking-map-marker-3">
                <FaMapMarkerAlt />
              </div>
            </div>

            <div className="tracking-card tracking-card-speed">
              <div className="tracking-card-icon"><FaTachometerAlt /></div>
              <div className="tracking-card-info">
                <span className="tracking-card-label">Vitesse</span>
                <span className="tracking-card-value">62 km/h</span>
              </div>
            </div>
            <div className="tracking-card tracking-card-position">
              <div className="tracking-card-icon"><FaMapMarkerAlt /></div>
              <div className="tracking-card-info">
                <span className="tracking-card-label">Position</span>
                <span className="tracking-card-value">Kinshasa, RDC</span>
              </div>
            </div>
            <div className="tracking-card tracking-card-status">
              <div className="tracking-card-icon"><FaCheckCircle /></div>
              <div className="tracking-card-info">
                <span className="tracking-card-label">Statut</span>
                <span className="tracking-card-value">En mouvement</span>
              </div>
            </div>
          </div>

          <div className="tracking-info">
            <h3>Une visibilité totale sur vos véhicules</h3>
            <p>
              Suivez chaque véhicule de votre flotte en temps réel, consultez l'historique
              des déplacements et optimisez vos itinéraires pour réduire les coûts
              et améliorer l'efficacité de vos opérations.
            </p>
            <div className="tracking-features">
              {features.map((feature, index) => (
                <div className="tracking-feature" key={index}>
                  <div className="tracking-feature-icon">{feature.icon}</div>
                  <span>{feature.text}</span>
                </div>
              ))}
            </div>
            <a href="#contact" className="btn btn-primary btn-lg">
              En savoir plus <FaArrowRight className="btn-icon" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tracking;
